var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"403-container"},[_c('errorPage',{attrs:{"title":_vm.$t('errorPages.title403'),"headline":_vm.$t('errorPages.headline403'),"message":_vm.$t('errorPages.message403')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }